import { createUseStyles } from 'react-jss'
import { colors } from '../../variables.style'

export const FILTER_MARGIN = 5

export const style = {
  container: {
    composes: 'flex-row',
    marginBottom: 10
  },
  select: {
    flex: '0 0 25%',
    '&:not(:last-child)': {
      paddingRight: 10
    }
  },
  endSection: {
    flex: '1 0 auto',
    alignSelf: 'flex-end',
    display: 'flex',
    justifyContent: 'flex-end',
    '& > :last-child': {
      marginLeft: 20
    }
  },
  switchOnPrimaryRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    height: 42
  },
  switchOnFilterRow: {
    flex: '1 1 auto',
    display: 'flex',
    justifyContent: 'flex-end',
    height: 32,
    alignSelf: 'flex-end'
  },
  filterContainer: {
    composes: 'flex-row',
    justifyContent: 'center',
    padding: 30,
    border: `1px solid ${colors.silver}`,
    backgroundColor: colors.concrete
  },
  applyButton: {
    alignSelf: 'flex-end',
    marginLeft: 10
  },
  downCaret: {
    fontSize: 12,
    marginLeft: 7,
    position: 'relative',
    top: 2
  },
  sliderContainer: {
    flex: '0 0 25%',
    padding: '0 20px'
  },
  standaloneFilterRow: {
    composes: 'flex-row',
    marginBottom: 10
  }
}

export const useStyles = createUseStyles(style)
